// import axios from 'axios'
import request from '@/utils/request'

const mixin = {
  components: {},
  filters: {},
  data() {
    return {}
  },
  created() {
  },
  methods: {
    async $page(entityName, params) {
      return await get(`/common/selectPages/${entityName}`, params)
      // return await get(`${entityName}/page`, params)
    },
    async $list(entityName, params) {
      return await get(`/common/selectLists/${entityName}`, params)
      // return await get(`${entityName}/list`, params)
    },
    async $one(entityName, id) {
      return await get(`/common/selectOne/${entityName}/${id}`)
      // return await get(`${entityName}/getOne/${id}`)
    },
    async $insert(entityName, data) {
      await post(`/common/insert/${entityName}`, data)
    },
    async $saveOrUpdate(entityName, data) {
      await post(`/common/insertOrUpdate/${entityName}`, data)
    },
    async $updateById(entityName, data) {
      await post(`/common/update/${entityName}`, data)
    },
    async $deleteById(entityName, id) {
      await post(`/common/delete/${entityName}/${id}`)
    }
  }
}
export default mixin

export const $page = mixin.methods.$page

export async function get(url, params) {
  return (await request.get(url, { params })).data
}
async function post(url, data) {
  return (await request.post(url, data)).data
}
